'use client';

import { usePendingGoogleRegistrationCompletion } from '@/features/v2/auth/register/hooks/usePendingGoogleRegistrationCompletion';

export const PendingGoogleRegistrationWatcher = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  usePendingGoogleRegistrationCompletion();
  return children;
};
